// src/constants/desktopRelease.js
// ============================================================================
// CRITCAST DESKTOP RELEASE FACTS (design S7.2, S8.1, S8.3 I4)
//
// Written by `critcash-desktop/scripts/release.js build --version <v>` inside
// P15 step 1 and committed in that same commit, so the hosting build carries
// the facts of the exact installer that step 7 uploads. Do not edit by hand.
//
// After a build the object reads:
//   { version, sha256, sizeBytes, url, releasedAt, signed }
// Until the first build only `version: null` is set.
//
// Readers (the Go Live modal and the /download page) use sha256, sizeBytes
// and signed ONLY when DESKTOP_RELEASE.version equals the version that the
// public getDesktopClientInfo callable returns. `url` is never rendered as a
// link: the download link always comes from the callable's downloads.windows.
// ============================================================================

export const DESKTOP_RELEASE = { version: '2.1.0', sha256: 'f51e82a4e9d4556a13f8b46798a86d6ea7f5e2029da84f081ca0bd6d15ee35a2', sizeBytes: 114418402, url: 'https://storage.googleapis.com/critcash-desktop-releases/desktop/CritCast-Setup-2.1.0.exe', releasedAt: '2026-10-25T17:09:50.515Z', signed: false };
